import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

function CoachesList({ coach, showArrow, isSelected = false }) {
  return (
    <div
      className={`shadow rounded-lg border px-3 py-2 mb-2 flex items-center transition-colors ${
        isSelected
          ? "border-red-300 bg-red-50 border-l-4"
          : "border-gray-200 hover:border-gray-300 hover:bg-gray-50"
      }`}
    >
      <div className="flex space-x-4 items-center">
        <div className="h-[40px] w-[40px] overflow-hidden rounded-md">
          <img
            alt={coach.name}
            src={coach.profilePicture || "/default-profile-img.png"}
            className="h-full w-full object-cover"
          />
        </div>
        <div className="overflow-hidden max-w-[200px]">
          <h2 className="text-base lg:text-lg uppercase truncate ">
            {coach.name} {coach.lastname}
          </h2>
          <p className="text-sm text-gray-700 break-words">
            {coach.university}
          </p>
        </div>
      </div>
      {showArrow && (
        <div
          className={`ml-auto ${isSelected ? "text-red-300" : "text-gray-300"}`}
        >
          <FontAwesomeIcon
            icon={faChevronRight}
            className="text-2xl font-bold"
          />
        </div>
      )}
    </div>
  );
}

export default CoachesList;
